export default class Piece {
  constructor (size) {
    this.size = size
    this.id = this.generateId()
    this.color = ''

    this.libelle = ''

    this.type1 = null
    this.type2 = null

    this.firstInPosition = null
  }

  generateId () {
    return Math.floor(Math.random() * 9999999)
  }

  generateColor (libelle) {
    if (libelle === 'eau') { return '#A0DADE' }
    if (libelle === 'air') { return '#4BBA70' }
    if (libelle === 'terre') { return '#CA6162' }
    if (libelle === 'feu') { return '#C92B2B' }

    if (libelle === 'glace') { return 'azure' }
    if (libelle === 'boue') { return 'Chocolate' }
    if (libelle === 'vapeur') { return 'MediumOrchid' }
    if (libelle === 'sable') { return 'wheat' }
    if (libelle === 'orage') { return 'gold' }
    if (libelle === 'roche') { return 'gray' }
  }

  generateLibelle (type1, type2) {
    if (type1 === 1) {
      if (type2 === 2) return 'glace'
      if (type2 === 3) return 'boue'
      if (type2 === 4) return 'vapeur'
      if (type2 === null) return 'eau'
    } else if (type1 === 2) {
      if (type2 === 1) return 'glace'
      if (type2 === 3) return 'sable'
      if (type2 === 4) return 'orage'
      if (type2 === null) return 'air'
    } else if (type1 === 3) {
      if (type2 === 1) return 'boue'
      if (type2 === 2) return 'sable'
      if (type2 === 4) return 'roche'
      if (type2 === null) return 'terre'
    } else if (type1 === 4) {
      if (type2 === 1) return 'vapeur'
      if (type2 === 2) return 'orage'
      if (type2 === 3) return 'roche'
      if (type2 === null) return 'feu'
    }
  }

  addType (type) {
    if (this.type1 === null) {
      this.type1 = type
    } else {
      this.type2 = type
    }
    if (this.size === 1 && this.type1 !== null) {
      this.libelle = this.generateLibelle(this.type1, null)
      this.color = this.generateColor(this.libelle)
    } else if (this.type1 !== null && this.type2 !== null) {
      this.libelle = this.generateLibelle(this.type1, this.type2)
      this.color = this.generateColor(this.libelle)
    }
  }

  get size () { return this._size }
  set size (value) { this._size = value }

  get id () { return this._id }
  set id (value) { this._id = value }

  get color () { return this._color }
  set color (value) { this._color = value }

  get firstInPosition () { return this._firstInPosition }
  set firstInPosition (value) { this._firstInPosition = value }
}
